import axios from "axios";

const useLocalhost = false;
const prodUrl = "https://saapapi.scatterblue.com/v1";

const axiosClientIam = axios.create({
  baseURL: useLocalhost ? "http://localhost:3101" : `${prodUrl}/iam`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Add a response interceptor
axiosClientIam.interceptors.response.use(
  (response) => {
    return response.data.Data;
  },
  (error) => {
    return Promise.reject(error); // Always return a rejected Promise in case of error
  }
);

const axiosClient = axios.create({
  baseURL: useLocalhost ? "http://localhost:3100" : `${prodUrl}/saa`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Add a response interceptor
axiosClient.interceptors.response.use(
  (response) => {
    return response.data.Data;
  },
  (error) => {
    return Promise.reject(error); // Always return a rejected Promise in case of error
  }
);

var token = null;

class HttpService {
  async login(user, password) {
    let resp = await axiosClientIam.post("/auth/login", {
      tenantId: "saapdev",
      clientId: "smartstore",
      username: user,
      password: password,
    });
    console.log("TOKEN SET:", resp);
    token = `Bearer ${resp.accessToken}`;
  }

  async loginWithOtp(phoneNumber, otp) {
    let resp = await axiosClientIam.post("/auth/login", {
      tenantId: "saapdev",
      clientId: "smartstore",
      username: phoneNumber,
      otp: otp || "",
    });
    console.log("TOKEN SET:", resp);
    if (resp.accessToken) token = `Bearer ${resp.accessToken}`;
  }

  /**
   * Post with url encoded data
   * @param url
   * @param options
   * @returns
   */

  async get(url, params, hdrs) {
    return await axiosClient.get(url, {
      params: params,
      headers: { Authorization: token },
    });
  }

  async post(url, data, hdrs) {
    console.log("TOKEN:", token);
    return await axiosClient.post(url, data, {
      headers: { Authorization: token },
    });
  }
}

export default HttpService;
